export { SkillHeavyLifter as default } from './SkillHeavyLifter';
